import styled from 'styled-components/macro'

const Spacer = styled.div`
    height: ${props => props.height};
    width: ${props => props.width ? props.width : (props.height ? '100%' : null)};
    background: ${props => props.background};
`;

export default Spacer